import useGetApi from 'src/api/useGetApi';

export interface WarehouseDTO {
  id: string;
  name: string;
  description?: string | null;
  address: {
    id: string;
    addressLine1: string;
    addressLine2: string | null;
    locality: string;
    administrativeArea: string | null;
    postalCode: string | null;
    countryIso31661Alpha2: string;
  } | null;
  metadata?: object | null;
  sectionCount: number;
  sections?: {
    id: string;
    name: string;
    description: string | null;
    type: string | null;
    status: string;
    capacity: object | null;
    metadata: object | null;
  }[];
}

interface ResponseDTO {
  warehouses: WarehouseDTO[];
}

const useWarehouses = (enabled?: boolean, includeSections?: boolean) => {
  return useGetApi<ResponseDTO>({
    endpoint: 'inventory-management/warehouses',
    queryParameters: {
      includeSections,
    },
    options: {
      enabled,
    },
  });
};

export default useWarehouses;
